import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/campanhas')({
  component: CampaignsLayout,
})

function CampaignsLayout() {
  return <Outlet />
}
